var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.551,
    height: 29,
    viewBox: "0 0 27.551 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Home",
    "data-name": "Iconly/Bold/Home",
    transform: "translate(-230.5 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(230.5 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    className: "cls-1",
    d: "M9.62,27.221V22.788a2.057,2.057,0,0,1,2.064-2.049h4.168a2.072,2.072,0,0,1,1.46.6,2.041,2.041,0,0,1,.6,1.449v4.434a1.759,1.759,0,0,0,.516,1.257A1.785,1.785,0,0,0,19.7,29h2.843a5.018,5.018,0,0,0,3.543-1.449,4.944,4.944,0,0,0,1.469-3.513V11.407a3.585,3.585,0,0,0-1.3-2.758L16.579.98a4.491,4.491,0,0,0-5.725.1L1.4,8.649A3.587,3.587,0,0,0,0,11.407V24.025A4.993,4.993,0,0,0,5.011,29H7.79a1.785,1.785,0,0,0,1.792-1.766Z",
    transform: "translate(0 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1bbab40148c2bc6e6812bce5908c5bb6.svg";
export { ForwardRef as ReactComponent };